<template>
    <div class="consult-container">
        <ComDetail :detail="detail" :detailCols="detailCols" :onCancel="onCancel"></ComDetail>
        <div class="search-container">
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item label="用户名称">
                    <el-input v-model="formInline.memberName" placeholder="请输入用户名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="table-container">
            <el-table v-loading="tableLoading" :data="tableData" :pagination="pagination" border style="width: 100%">
                <el-table-column prop="memberName" label="用户名" align="center">
                </el-table-column>
                <el-table-column prop="appCount" label="开通数" align="center">
                </el-table-column>
                <el-table-column label="操作" align="center" width="100">
                    <template slot-scope="scope">
                        <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 40]"
                    :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper"
                    :total="pagination.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { getUserAppList } from '@/api/SupermarketOperation'
import moment from "moment";
import ComDetail from '@/components/common/comDetail.vue';
export default {
    name: 'AdminStaticsUserApplication',
    components: {
        ComDetail
    },
    data() {
        return {
            tableLoading: false,
            detail: {
                visible: false,
                record: {},
            },
            detailCols: [
                {
                    label: '用户名',
                    prop: 'memberName'
                },
                {
                    label: '开通数',
                    prop: 'appCount',
                },
            ],
            formInline: {
                memberName: ''
            },
            pagination: {
                currentPage: 1, // 当前页
                pageSize: 10, // 每页显示条数
                total: 0, // 总条数
                layout: 'total, prev, pager, next, jumper', // 分页布局
            },
            tableData: [],
        };
    },

    mounted() {
        this.loadData()
    },
    methods: {

        // 查看
        onCancel() {
            this.detail.visible = false
        },
        // 时间转换
        dateFormat(row) {
            return moment(row.askDate).format('YYYY-MM-DD HH:mm:ss');
        },
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.loadData()
        },
        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.loadData()
        },
        handleClick(row) {
            this.detail.visible = true
            this.detail.record = row
        },
        onSubmit() {
            this.loadData()
        },
        async loadData() {
            this.tableLoading = true
            const params = {}
            if (this.formInline.memberName) {
                params.memberName = this.formInline.memberName
            }
            await getUserAppList({
                pageNo: this.pagination.currentPage - 1,
                pageSize: this.pagination.pageSize,
                ...params,
            }).then(res => {
                this.tableLoading = false
                this.tableData = res.data.content
                this.pagination.total = res.data.totalElements
            })
        }
    },
};
</script>
<style lang="scss" scoped>
.consult-container {
    background: #fff;
    padding: 24px 0;

    .search-container {
        padding: 0 16px;
        border-bottom: 1px solid #EBEEF5;
    }

    .table-container {
        padding: 16px;
    }

    .pagination-container {
        margin-top: 16px;
        text-align: right;
    }
}
</style>